/* eslint-disable no-console */
import StyledHeader, { MobileLogoArea } from './styles';

import NovidadesIcon from './assets/icone_novidades.svg';
import Contact from './components/Contact';
import GeoLogo from './components/GeoLogo';
import MobileNavSideBar from './components/MobileNavSideBar';
import ModuleSwitcher from './components/ModulesSwitcher';

import AppContext from '../../services/context';
import Mobile from '../Mobile';

import Icon from '@map/components/Icons';
import ButtonTooltip from '@map/components/ToolBar/components/ButtonTooltip';
/**
 * useState é um hook que nos permite rastrear o estado em um
 * componente de função, o estado geralmente se refere a dados ou
 * propriedads que precisam ser rastreador em um aplicativo.
 * 
 * useContext usado para forcener uma maneira de passar dados
 * pela arvore de componentes sem ter que passar props manualmente
 * em todos os níveis.
 * 
 * useEffect é um hook que permite executar efeitos colaterais em
 * seus componentes, por exemplo: buscar dados, atualizar diretamente
 * o DOM e cronômetros, ele aceita dois argumentos o segundo é opcional.
 */
import { useState, useContext, useEffect } from 'react';
/**
 *  useModules é responsavel por gerenciar os modulos do GeoBahia,
 *  todos os módulos criados na ADM.
 */
import { useModule } from 'views/MapView/hooks';

const HeadBar = (props) => {
  const [menuIsOpened, setMenuIsOpened] = useState(false);
  const { toogleSideBar, hidedInterface } = useContext(AppContext);
  const { activeModule } = useModule();

  useEffect(() => {
    const mediaQuery = window.matchMedia('(max-width: 768px)');

    const onChangeWindowSize = (paramMediaQuery) => {
      if (paramMediaQuery.matches) {
        // If media query matches
        setMenuIsOpened(false);
      } else {
        setMenuIsOpened(true);
      }
    };
    onChangeWindowSize(mediaQuery); // Call listener function at run time
    mediaQuery.addEventListener(true, onChangeWindowSize); // Attach listener function on state changes
  }, []);

  /**
   * @returns Retorna o tooltip do icone do GEOBAHIA
   * no MOBILE
   */
  return (
    <>
      <MobileNavSideBar />
      <StyledHeader isHided={hidedInterface}>
        <GeoLogo />
        {activeModule && !activeModule?.isMain && (
          <div className="module_title">{activeModule.titulo}</div>
        )}
        <Mobile>
          <button onClick={(e) => toogleSideBar('main-nav')}>
            <Icon i="map-menubars" />
          </button>
        </Mobile>
        {menuIsOpened && (
          <div className="right_options">
            <ButtonTooltip
              tooltip="Novidades"
              description="Descubra as novas funcionalidades e aprenda como aproveitar ao máximo o GeoBahia."
              style={{ padding: 0 }}
            >
              <a href={process.env.REACT_APP_LINK_LANDING_PAGE} target="_blank" rel="noopener noreferrer" style={{ display: 'flex'}}>
                <img
                  src={NovidadesIcon}
                  className="novidades-icon"
                  alt="Novidades"
                />
              </a>
            </ButtonTooltip>
            <ButtonTooltip
              tooltip="Módulos"
              description="Navegue entre as diferentes ferramentas e sistemas especializados do GeoBahia."
              style={{ padding: 0 }}
            >
              <ModuleSwitcher />
            </ButtonTooltip>
            <ul>
              {/*   <li>Tour</li> */}
              <ButtonTooltip
                tooltip="Contato"
                description="Dúvidas ou sugestões? Envie uma mensagem para nossa equipe de suporte."
                style={{ padding: 0 }}
              >
                <li style={{ color: 'white' }}>
                  <Contact />
                </li>
              </ButtonTooltip>
            </ul>
            {/*   <UserZone /> */}
          </div>
        )}
      </StyledHeader>
      <Mobile>
        <MobileLogoArea>
          <GeoLogo />
          <img
            src={NovidadesIcon}
            width="auto"
            height="27"
            className="novidades-icon"
            alt="Novidades"
            title="Novidades do Geobahia."
          />
          {activeModule && !activeModule?.isMain && (
            <div className="module_title">
              <div className="separator"></div>
              {activeModule.titulo}
            </div>
          )}
        </MobileLogoArea>
      </Mobile>
    </>
  );
};

HeadBar.properties = {
  id: 'CPN-HEAD_BAR',
  alias: 'Barra de título',
  description: '...',
};


export default HeadBar;
